import { render, staticRenderFns } from "./ProjectLesson.vue?vue&type=template&id=b81952a8&scoped=true&"
import script from "./ProjectLesson.vue?vue&type=script&lang=js&"
export * from "./ProjectLesson.vue?vue&type=script&lang=js&"
import style0 from "./ProjectLesson.vue?vue&type=style&index=0&id=b81952a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81952a8",
  null
  
)

export default component.exports